import { carouselData } from '@/mocks/home';

const topThree = carouselData.slice(0, 3);
const bottomTwo = carouselData.slice(3);

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 text-xs font-medium text-accent-400 mb-3">
            <i className="ri-layout-grid-line"></i>
            专题策划
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精选专题</h2>
          <p className="mt-2 text-sm text-foreground-500">编辑部为你精心策划的影视主题</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {topThree.map((item) => (
            <div
              key={item.id}
              className="group rounded-2xl bg-background-100 border border-background-200/60 overflow-hidden hover:border-primary-500/30 transition-all duration-300"
            >
              <div className="aspect-[3/2] relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100/80 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-[10px] font-semibold">{item.tag}</span>
                  <span className="px-2.5 py-1 rounded-full bg-background-100/70 text-foreground-600 text-[10px] font-medium backdrop-blur-sm">{item.category}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-800 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {bottomTwo.map((item) => (
            <div
              key={item.id}
              className="group flex flex-col sm:flex-row rounded-2xl bg-background-100 border border-background-200/60 overflow-hidden hover:border-primary-500/30 transition-all duration-300"
            >
              <div className="sm:w-48 aspect-[3/2] sm:aspect-auto relative overflow-hidden flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-background-100/30"></div>
              </div>
              <div className="flex-1 p-4 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-full bg-accent-500/15 text-accent-400 text-[10px] font-semibold">{item.tag}</span>
                  <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-600 text-[10px] font-medium">{item.category}</span>
                </div>
                <h3 className="font-heading text-sm font-bold text-foreground-800 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}